// @owners { team: patients }
import { type BACKGROUND_COLORS_VALUES, COLORS } from '@alto/design-library-tokens';
import { type AppPromoCardType } from '@alto/scriptdash/alto/patients/engagement/types/v1/app_promo';

const KEY_BY_CARD_TYPE: Record<AppPromoCardType, keyof typeof COLORS.BACKGROUND_COLORS> = {
  primary_lighter: 'PRIMARY_LIGHTER',
  secondary_lighter: 'SECONDARY_LIGHTER',
  pink_lighter: 'PINK_LIGHTER',
  tertiary_lighter: 'TERTIARY_LIGHTER',
  success_lighter: 'SUCCESS_LIGHTER',
  warning_lighter: 'WARNING_LIGHTER',
};

export const getPromoCardBackgroundColor = (cardType?: AppPromoCardType): BACKGROUND_COLORS_VALUES => {
  const colorKey = cardType ? KEY_BY_CARD_TYPE[cardType] : undefined;
  return COLORS.BACKGROUND_COLORS[colorKey ?? 'PRIMARY_LIGHTER'];
};
